import { lazy } from 'react';

import { UiRoutes } from '@src/lib/constants';
import { routesConfigType } from '@src/lib/types';
import FloorPage from '@src/screens/DynamicFloor';
import RoomDisplay from '@src/screens/RoomDisplay';

// const Dashboard = lazy(() => import('../screens/Dashboard'));
const Login = lazy(() => import('../screens/Login'));
const Home = lazy(() => import('../screens/Home'));
const Rooms = lazy(() => import('@src/screens/RoomManagement'));
const Locations = lazy(() => import('@src/screens/Locations'));
const Booking = lazy(() => import('@src/screens/Booking'));
const NewBooking = lazy(() => import('@src/screens/NewBooking'));
const Users = lazy(() => import('@src/screens/Users'));
const Scheduling = lazy(() => import('@src/screens/Schedulling'));
const Devices = lazy(() => import('@src/screens/Devices'));
const Organization = lazy(() => import('@src/screens/Organization'));
const DeviceLogList = lazy(() => import('@src/screens/HomeAssistantLog/DeviceLogList'));
const DeviceList = lazy(() => import('@src/screens/HomeAssistantLog/DeviceList'));
const NabuCasaInstances = lazy(() => import('@src/screens/NabuCasa'));

const routesConfig: Array<routesConfigType> = [
  // {
  //   path: UiRoutes.DASHBOARD,
  //   component: Dashboard,
  //   layout: 'private',
  //   allowedPermission: 'dashboard',
  // },
  {
    path: UiRoutes.LOGIN,
    component: Login,
    layout: 'public',
    allowedPermission: 'all',
  },
  {
    path: UiRoutes.ORGANIZATION,
    component: Organization,
    layout: 'private',
    allowedPermission: 'manageOrganizations',
  },
  {
    path: UiRoutes.METRICS,
    component: Home,
    layout: 'private',
    allowedPermission: 'home',
  },
  {
    path: UiRoutes.ROOMS_MANAGEMENT,
    component: Rooms,
    layout: 'private',
    allowedPermission: 'rooms',
  },
  {
    path: UiRoutes.LOCATIONS_MANAGEMENT,
    component: Locations,
    layout: 'private',
    allowedPermission: 'locations',
  },
  {
    path: UiRoutes.USERS_MANAGEMENT,
    component: Users,
    layout: 'private',
    allowedPermission: 'users',
  },
  {
    path: UiRoutes.SCHEDULING,
    component: Scheduling,
    layout: 'private',
    allowedPermission: 'scheduling',
  },
  {
    path: UiRoutes.BOOKING,
    layout: 'private',
    component: Booking,
    allowedPermission: 'bookings',
  },
  {
    path: UiRoutes.DEVICES,
    component: Devices,
    layout: 'private',
    allowedPermission: 'devices',
  },
  {
    path: UiRoutes.DEVICE_LOG_HA_ID,
    component: DeviceLogList,
    layout: 'private',
    allowedPermission: 'devices',
  },
  {
    path: UiRoutes.DEVICE_LOG_HA,
    component: DeviceList,
    layout: 'private',
    allowedPermission: 'devices',
  },
  {
    path: UiRoutes.ROOM_DYNAMIC_FLOOR,
    component: FloorPage,
    layout: 'private',
    allowedPermission: 'rooms',
  },
  {
    path: UiRoutes.NEW_BOOKING,
    component: NewBooking,
    layout: 'private',
    allowedPermission: 'bookings',
  },
  {
    path: UiRoutes.ROOM_DETAILS,
    component: RoomDisplay,
    layout: 'private',
    allowedPermission: 'room_display',
  },
  {
    path: UiRoutes.NABU_CASA,
    component: NabuCasaInstances,
    layout: 'private',
    allowedPermission: 'manageOrganizations',
  },
];

export default routesConfig;
